import React, {Component} from 'react';
import moment from 'moment';
import Step6 from "./WizardSteps/step6";
import _ from 'lodash';
import accounting from 'accounting';
import Button from "../button";
import { CURRENCY } from '../../helpers/variables';
import PercentageStep6 from "./WizardSteps/percentageStep6";
import { PS_TYPE_PERCENTAGE } from '../../helpers/constants';


class PremiumSettingsCombinationTable extends Component {

	constructor(props){
		super(props);
		this.state = {
			featuredItems: []
		}
	}

	onItemSelect = (itemId) => {
		let newItems = [...this.state.featuredItems];
		if(this.state.featuredItems.includes(itemId)){
			newItems = newItems.filter(item => item !== itemId);
		} else {
			newItems = [...newItems, itemId]
		}

		this.setState({
			...this.state,
			featuredItems: newItems
		});
	};

	//function that calculates the damage band label
	getDamageBandName = (damageBand) => {
		let damages = [...this.props.allPossibleDamages.damages];
		if (damageBand.length === damages.length) {
			return 'Unlimited'
		}
		else {
			if (_.last(damageBand).highValue === 0) {
				return 'Over ' + accounting.formatMoney(damageBand[0].lowValue - 1, `${CURRENCY} `, 0);
			}
			else {
				return accounting.formatMoney(damageBand[0].lowValue, `${CURRENCY} `, 0) + ' - ' + accounting.formatMoney(_.last(damageBand).highValue, `${CURRENCY} `, 0);
			}
		}
	};

	getDamageBands = (item) => {
		let dmgBands=[];
		let dmgs = [];
		let subSettings = this.props.psType === PS_TYPE_PERCENTAGE ? item.percentagePremiumSubSettings : item.premiumSubSettings;
		let firstStage = subSettings[0].stageId;
		_.forEach(subSettings, (data, index) => {
			if(data.stageId === firstStage ) {
				let dam = [];
				_.forEach(data.damages, damage => {
					dam.push(_.find(this.props.allPossibleDamages.damages, item => {
						return item.id === damage.id
					}))
				});
				dmgs.push(...dam);
				if (dmgs.length <= this.props.allPossibleDamages.damages.length)
					dmgBands.push(dam)
			}
		});
		return dmgBands;
	};

	//function that calculated the table header data
	getTableHeaderData = (item) => {
		let dmgBands=this.getDamageBands(item);
		let headerData = [{width: '47px', label: ''}, {width: '141px', label: ''}];
		_.forEach(dmgBands, band => {
			headerData.push({
				width: '188px',
				label: this.getDamageBandName(band)
			})
		});
		return headerData
	};


	//function that calculated the table header data
	getSelectedCaseStages = (item) => {
		let caseStages=[];
		let subSettings = this.props.psType === PS_TYPE_PERCENTAGE ? item.percentagePremiumSubSettings : item.premiumSubSettings;
		_.forEach(subSettings, (data, index) => {
			let exists = caseStages.filter(cs => cs.id === data.stageId);
			if(exists.length === 0){
				caseStages.push({id: data.stageId, name: data.stageName})
			}
		});
		return caseStages;
	};

	//function that constructs the table data object
	getTableDataObj = (data) => {
		let tData = [];
		let subSettings = this.props.psType === PS_TYPE_PERCENTAGE ? data.percentagePremiumSubSettings : data.premiumSubSettings;
		_.forEach(subSettings, subSetting => {
			let tmp = [];
			_.forEach(subSetting.premiumSubSettingCommissions, item => {
				tmp.push({
                    lawsysName: item.lawsysName,
					lawsysId: item.lawsysId,
					commission: item.commission ? item.commission.toString() : '',
					commissionPercentage: item.commissionPercentage.toString()
				})
			});
			tData.push({
				stageId: subSetting.stageId,
				stageName: subSetting.stageName,
				premium: subSetting.premium ? subSetting.premium.toString() : '',
				recoverable: subSetting.recoverable ? subSetting.recoverable.toString() : '',
				nonRecoverable: subSetting.nonRecoverable ? subSetting.nonRecoverable.toString() : '',
				underwriterRate: subSetting.underwriterRate ?subSetting.underwriterRate.toString() : '',
				underwriterRatePercentage: subSetting.underwriterRatePercentage ? subSetting.underwriterRatePercentage.toString() : '',
				recoverableRatePercentage: subSetting.recoverableRatePercentage ? subSetting.recoverableRatePercentage.toString() : '',
				premiumSubSettingCommissions: tmp,
				damages: subSetting.damages
			})
		});
		return tData;
	};

	//function that find solicitor by id
	getSolicitor = (solicitorId) => {
		return _.find(this.props.lawsysFirms.lawsysFirms, item => {
			return item.id === solicitorId ;
		})
	};

	render() {
		return (
			<div className="row">
				<div className="col-sm-12 ">
					<ul id="sortable" className="unorderedListNoBulletsAndSpace">
						{
							this.props.data.map((item, index) => {
								return (
									<li key={index} className="refSettingsListItem">
										<a
											onClick={() => this.onItemSelect(item.id)}
											className={`refToggle`}
										>
											{new Date(item.validFrom).toLocaleDateString('en-GB') + (item.validUntil ? (' - ' + new Date(item.validUntil).toLocaleDateString('en-GB')) : '')}
										</a>
										<div className={`refInner ${this.state.featuredItems.includes(item.id)?'show':''}`}>
											<Button wrapper="btn-wrapper-forForms" btnType="button"
													clickHandler={() => {
                                                        if (this.props.psType === 'default') {
                                                            this.props.changeNewPremiumStoreSettings('selectedSolicitorGroup', '');
                                                            this.props.changeNewPremiumStoreSettings('selectedWorksource', '');
                                                        }
														this.props.push('premium-settings/edit-premium-settings/' + item.id)
                                                    }}
													btnStyle={'btn btn-primary btn-xs sharp white'}
													label="Edit"/>
											<form className="form-horizontal">
											{
											this.props.psType === PS_TYPE_PERCENTAGE ? 											
												<PercentageStep6
													solicitorListLength={item.percentagePremiumSubSettings[0].premiumSubSettingCommissions.length}
													showTable={true}
													selectedCaseType={item.caseTypeName}
													selectedSubCaseType={item.selectedSubCaseType}
													getSolicitor={this.getSolicitor}
													posting={item.posting}
													tableData={this.getTableDataObj(item)}
													damageBands={[]}
													getDamageBands = {() => this.getDamageBands(item)}
													getSelectedCaseStages = {() => this.getSelectedCaseStages(item)}
													selectedCaseStages={[]}
													solicitorsList={[]}
													getTableHeaderData={() => this.getTableHeaderData(item)}
													limitOfIndemnity={item.limitOfIndemnity}
													validFrom={item.validFrom}
													validUntil={item.validUntil}
													notes={item.notes.notes}
													endorsements={item.endorsements}
													comments={item.comments}
													currentStep={6}
													badResponseMsg=""
													successMsg=""
													displayedCoverageType={item.coverageOptionName}
													displayedDeductible={item.deductibleOptionName}
													displayedEndorsement={item.endorsementOptionName}
													recoverableRatePercentage={item.percentagePremiumSubSettings[0].recoverableRatePercentage}						
												/> :
												<Step6
													solicitorListLength={item.premiumSubSettings[0].premiumSubSettingCommissions.length}
													showTable={true}
													selectedCaseType={item.caseTypeName}
													selectedSubCaseType={''}
													getSolicitor={this.getSolicitor}
													tableData={this.getTableDataObj(item)}
													damageBands={[]}
													getDamageBands = {() => this.getDamageBands(item)}
													getSelectedCaseStages = {() => this.getSelectedCaseStages(item)}
													selectedCaseStages={[]}
													solicitorsList={[]}
													getTableHeaderData={() => this.getTableHeaderData(item)}
													limitOfIndemnity={item.limitOfIndemnity}
													validFrom={item.validFrom}
													validUntil={item.validUntil}
													notes={item.notes}
													endorsements={item.endorsements}
													comments={item.comments}
													currentStep={6}
													badResponseMsg=""
													successMsg=""
													displayedCoverageType={item.coverageOptionName}
													displayedDeductible={item.deductibleOptionName}
													displayedEndorsement={item.endorsementOptionName}
												/>
												}
											</form>
										</div>
									</li>
								)
							})
						}
					</ul>
				</div>
			</div>
		)
	}
};

export default PremiumSettingsCombinationTable;
